import createSelector from "../../Utils/reselect";

const vertex360CopilotStateData = (state) => state.vertex360Copilot || {};

const toPlainMessages = (messages) => {
  if (!messages) return [];
  return typeof messages.toJS === "function" ? messages.toJS() : messages;
};

export const getVertex360CopilotMessages = createSelector(
  vertex360CopilotStateData,
  (copilot) => toPlainMessages(copilot.get("messages"))
);

export const getVertex360CopilotIsAssistantTyping = createSelector(
  vertex360CopilotStateData,
  (copilot) => copilot.get("isAssistantTyping") || false
);

export const getVertex360CopilotIsStreaming = createSelector(
  vertex360CopilotStateData,
  (copilot) => copilot.get("isStreaming") || false
);

export const getVertex360CopilotStreamingMessageId = createSelector(
  vertex360CopilotStateData,
  (copilot) => copilot.get("streamingMessageId") || null
);

export const getVertex360CopilotIsLoadingOlder = createSelector(
  vertex360CopilotStateData,
  (copilot) => copilot.get("isLoadingOlder") || false
);

export const getVertex360CopilotHasMoreOlder = createSelector(
  vertex360CopilotStateData,
  (copilot) => copilot.get("hasMoreOlder") || false
);

export const getVertex360CopilotNextBeforeId = createSelector(
  vertex360CopilotStateData,
  (copilot) => copilot.get("nextBeforeId") || null
);

export const getVertex360CopilotMessagesPageSize = createSelector(
  vertex360CopilotStateData,
  (copilot) => {
    const pageSize = copilot.get("messagesPageSize");
    return pageSize && Number(pageSize) > 0 ? Number(pageSize) : null;
  }
);

export const getVertex360CopilotHasConversation = createSelector(
  getVertex360CopilotMessages,
  (messages) => messages.length > 0
);

export const getVertex360CopilotIsBusy = createSelector(
  getVertex360CopilotIsAssistantTyping,
  getVertex360CopilotIsStreaming,
  (isAssistantTyping, isStreaming) => isAssistantTyping || isStreaming
);

export const getVertex360CopilotError = createSelector(
  vertex360CopilotStateData,
  (copilot) => copilot.get("error") || null
);

export const getVertex360CopilotConversationId = createSelector(
  vertex360CopilotStateData,
  (copilot) => copilot.get("conversationId") || null
);

export const getVertex360CopilotActiveFilters = createSelector(
  vertex360CopilotStateData,
  (copilot) => {
    const filters = copilot.get("activeFilters");
    if (!filters) return null;
    return typeof filters.toJS === "function" ? filters.toJS() : filters;
  }
);

export const getVertex360CopilotContextSummary = createSelector(
  vertex360CopilotStateData,
  (copilot) => copilot.get("contextSummary") || null
);
